import { render, staticRenderFns } from "./SmooRoleIcon.vue?vue&type=template&id=3eceeba1&"
import script from "./SmooRoleIcon.vue?vue&type=script&lang=js&"
export * from "./SmooRoleIcon.vue?vue&type=script&lang=js&"
import style0 from "./SmooRoleIcon.vue?vue&type=style&index=0&id=3eceeba1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports